import { render, staticRenderFns } from "./ShipperItemEditLicensesPage.vue?vue&type=template&id=2ec85304&"
import script from "./ShipperItemEditLicensesPage.vue?vue&type=script&lang=js&"
export * from "./ShipperItemEditLicensesPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipperItemEditLicensesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports